import { Flex, Text, Icon } from './';
import { videoOn, hamburgerHorizontal, menuClose, videoOff, personProfile, notesClipboard } from '../../icons';
import { theme } from '../../design-system';
import { useAuth } from '../../../../context/authContext';
import { useVideo } from '../../../../context/videoContext';

const NavBarLogo = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 115 85' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M66.8438 80.5H47.5813L79.7813 7.76245H99.1875L66.8438 80.5Z' fill='#25BECB' />
      <path d='M66.8438 80.5H47.5813L79.7813 7.76245H99.1875L66.8438 80.5Z' fill='url(#paint0_linear_21_619)' />
      <path d='M66.8437 80.5L59.0812 54.625L57.2125 58.65L66.8437 80.5Z' fill='url(#paint1_linear_21_619)' />
      <path d='M47.4375 36.3687H28.175L47.5812 80.4999H66.8438L47.4375 36.3687Z' fill='#49BC99' />
      <defs>
        <linearGradient id='paint0_linear_21_619' x1='56.1873' y1='80.2242' x2='90.1072' y2='8.70603' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#25BECB' />
          <stop offset='1' stopColor='#25BECB' stopOpacity='0' />
        </linearGradient>
        <linearGradient id='paint1_linear_21_619' x1='57.2526' y1='67.5096' x2='66.8481' y2='67.5096' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#25BECB' />
          <stop offset='1' stopColor='#25BECB' stopOpacity='0' />
        </linearGradient>
        <linearGradient id='paint2_linear_21_619' x1='56.2646' y1='79.1057' x2='37.8742' y2='35.786' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#49BC99' />
          <stop offset='1' stopColor='#49BC99' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  );
};

const TopNavBar = ({
  showNotes,
  setShowNotes,
  menuOpen,
  setMenuOpen,
  videoChatScreenOpen,
  setVideoChatScreenOpen,
  showVideoSidebar,
  patientView,
}) => {
  const { logout } = useAuth();
  const { disconnect } = useVideo();

  const performLogout = () => {
    if (window.confirm('Are you sure you want to leave the session?')) {
      logout();
      disconnect();
    }
  };

  return (
    <Flex
      width='100vw'
      backgroundColor={theme.colors.backgroundNeutral}
      justifyContent='space-between'
      alignItems='center'
      height='55px'
      padding='0.75rem'
      style={{ position: 'sticky', top: 0, left: 0 }}
      zIndex='100'
    >
      <Flex width='12vw' minWidth='70px' maxWidth='90px' column alignItems='flex-start'>
        {patientView ? (
          <Flex column centered>
            <Icon icon={personProfile} onClick={() => performLogout()} color={theme.colors.primary} />
            <Text color={theme.colors.primary} fontSize='.625rem'>
              {'Leave'}
            </Text>
          </Flex>
        ) : (
          <Icon
            icon={menuOpen ? menuClose : hamburgerHorizontal}
            onClick={() => {
              setMenuOpen(!menuOpen);
              if (showNotes) setShowNotes(false);
              return videoChatScreenOpen && setVideoChatScreenOpen(false);
            }}
          />
        )}
      </Flex>
      <Flex centered>
        <NavBarLogo />
        <Text size='h2'>IbisVision</Text>
      </Flex>
      <Flex column centered width='12vw' minWidth='70px' maxWidth='90px' height='55px'>
        {!patientView ? (
          <Flex width='100%' justifyContent='space-between'>
            <Flex column>
              <Icon
                color={showNotes ? 'lightgrey' : theme.colors.primary}
                icon={notesClipboard}
                height='30px'
                onClick={() => {
                  setShowNotes(true);
                  if (menuOpen) setMenuOpen(false);
                  return videoChatScreenOpen && setVideoChatScreenOpen(false);
                }}
              />
              <Text color={showNotes ? 'lightgrey' : theme.colors.primary} fontSize='.625rem'>
                Notes
              </Text>
            </Flex>
            <Flex column>
              <Icon
                color={showVideoSidebar ? 'lightgrey' : theme.colors.primary}
                icon={videoChatScreenOpen || showVideoSidebar ? videoOff : videoOn}
                height='30px'
                onClick={
                  showVideoSidebar
                    ? null
                    : () => {
                        setVideoChatScreenOpen(!videoChatScreenOpen);
                        if (showNotes) setShowNotes(false);
                        return menuOpen && setMenuOpen(false);
                      }
                }
              />
              <Text color={showVideoSidebar ? 'lightgrey' : theme.colors.primary} fontSize='.625rem'>
                Video
              </Text>
            </Flex>
          </Flex>
        ) : null}
      </Flex>
    </Flex>
  );
};
export default TopNavBar;
